import {Tabs, Tab, Grid} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_OTHER, TAB_OBS_COUNT} from './StatsCommon.js';
import StatsProgress from './StatsProgress.js';
import StatsObsCount from './StatsObsCount.js';
import StatsTrip from './StatsTrip.js';

const StatsOther = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const handleTabChange = (event, tab) => {
		gStorage.stats.setObsList(null);
		gStorage.stats.setOtherTab(tab + TAB_OBS_COUNT);
	}

	if (gStorage.stats.tab !== TAB_OTHER)
		return null;

	return (
		<>
			<Grid container direction="row" justifyContent="center" spacing={0} columns={1}>
				<Tabs
					value={gStorage.stats.other_tab - TAB_OBS_COUNT}
					onChange={handleTabChange} 
					align={'center'}
					indicatorColor="primary"
					textColor="primary"
					scrollButtons="auto"
					variant="scrollable"
					sx={{mb: 1}}>
					<Tab label={t('stats.obs_count')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.progress')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.trips')} disabled={!gStorage.conn.online}/>
				</Tabs>
			</Grid>

			<StatsObsCount />
			<StatsProgress/>
			<StatsTrip/>
		</>
	);
});

export default StatsOther;
